import { HTTP_TOKEN } from "./http";

export const getImports = params => {
  return HTTP_TOKEN.get("imports", { params }).then(result => {
    return result.data;
  });
};

export const createImport = data => {
  return HTTP_TOKEN.post("imports", data).then(result => {
    return result.data;
  });
};
